export default "__VITE_ASSET__DGeKtiZH__"